import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";
import List from "@material-ui/core/List";
import Divider from "@material-ui/core/Divider";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import CloseIcon from "@material-ui/icons/Close";

const useStyles = makeStyles({
  list: {
    width: 400,
  },
  fullList: {
    width: "auto",
  },
  pointer: {
    cursor: "pointer",
  },
});

export default function View(props) {
  const { onClose } = props;
  const classes = useStyles();
  const sideList = (side) => (
    <div className={classes.list} role="presentation">
      <div className="col-12 d-flex align-items-center justify-content-between py-4">
        <h1 className="h3 mb-0">Partner details</h1>
        <CloseIcon className={classes.pointer} onClick={onClose} />
      </div>
      <Divider className="bg-dark" />
      <List>
        <ListItem className="d-flex align-items-center justify-content-between">
          <ListItemText primary="Name" />

          <label className="text-right font-weight-bold h6 mb-0">Gold</label>
        </ListItem>
        <Divider />
        <ListItem className="d-flex align-items-center justify-content-between">
          <ListItemText primary="Score Limit" />

          <label className="text-right font-weight-bold h6 mb-0">30</label>
        </ListItem>
      </List>
    </div>
  );

  return (
    <Drawer {...props} anchor="right">
      {sideList("right")}
    </Drawer>
  );
}
